import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import apiUtils from '../helper/api.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.state = {
			categories: []
		}

		// hydrate as soon as initialized
		axios.get(`${apiUtils.getApiURL()}/categories?filter={"counts":"recipesInCategory"}`)
			.then(response => this.setState({ categories: _.sortBy(response.data, ['category']) }))
	}
}



// WEBPACK FOOTER //
// ./src/stores/categories.js